import { useAuth } from "@/modules/auth";
import { DealerFiltersProps } from "./types";
import { FilterDropdown } from "./FilterDropdown";
import { canViewDealerFilter } from "./permissions";

export function DealerFilters({ filters, filterOptions, onFilterChange, permissionsMap }: DealerFiltersProps) {
    const { user } = useAuth();

    const canViewOem = canViewDealerFilter("oem", user, permissionsMap);
    const canViewProduct = canViewDealerFilter("product", user, permissionsMap);
    const canViewGroup = canViewDealerFilter("group", user, permissionsMap);
    const canViewProgram = canViewDealerFilter("program", user, permissionsMap);
    const canViewState = canViewDealerFilter("state", user, permissionsMap);

    const hasAnyFilter = canViewOem || canViewProduct || canViewGroup || canViewProgram || canViewState;

    if (!hasAnyFilter) {
        return null;
    }

    return (
        <div className="flex gap-4 items-center w-full flex-wrap">
            <span className="font-inter font-medium text-menu-hover text-sm whitespace-nowrap">Filter:</span>
            <div className="flex gap-3 items-center flex-wrap">
                {canViewOem && (
                    <FilterDropdown
                        label="OEM"
                        values={filters.oem}
                        options={filterOptions.oem}
                        onChange={(values) => onFilterChange("oem", values)}
                    />
                )}
                {canViewProduct && (
                    <FilterDropdown
                        label="Product"
                        values={filters.product}
                        options={filterOptions.product}
                        onChange={(values) => onFilterChange("product", values)}
                    />
                )}
                {canViewGroup && (
                    <FilterDropdown
                        label="Group"
                        values={filters.group}
                        options={filterOptions.group}
                        onChange={(values) => onFilterChange("group", values)}
                    />
                )}
                {canViewProgram && (
                    <FilterDropdown
                        label="Program"
                        values={filters.program}
                        options={filterOptions.program}
                        onChange={(values) => onFilterChange("program", values)}
                    />
                )}
                {canViewState && (
                    <FilterDropdown
                        label="State"
                        values={filters.state}
                        options={filterOptions.state}
                        onChange={(values) => onFilterChange("state", values)}
                    />
                )}
            </div>
        </div>
    );
}
